import { Vector3 } from 'three'

export const DEFAULT_VIEWER_BACKGROUND =
  'radial-gradient(57.87% 54.67% at 50% 50%, #FFFFFF 0%, #D5D5D5 100%)'
export const DEFAULT_VIEWER_ID = 'ring_demo_store'
export const DEFAULT_VIEWER_TYPE = 'ring'
export const DEFAULT_CAMERA_POSITION = new Vector3(1.8, 3.2, 2.8)
export const ANIMATION_DURATION = 200
